import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="row-materials-search"
export default class extends Controller {
  static targets = ["select", "form", "searchForm", "input"]
  connect() {
    console.log("RowMaterialsSearchController connected");
    console.log(this.selectTargets);
    new TomSelect("#category_row_material_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
    });

    new TomSelect("#category_price_row_material_id",{
      sortField: {
        field: "text",
        direction: "asc"
      },
      maxOptions: null
    });
  }

  submit(e) {
    this.inputTarget.value = '';
   this.formTarget.requestSubmit(); 
  }

  submitSearch(e) {
    this.searchFormTarget.requestSubmit()
  }
}
